import _Object$values from "babel-runtime/core-js/object/values";
import _Set from "babel-runtime/core-js/set";
import _Array$from from "babel-runtime/core-js/array/from";
import _JSON$stringify from "babel-runtime/core-js/json/stringify";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _Object$keys from "babel-runtime/core-js/object/keys";
import _Promise from "babel-runtime/core-js/promise";
import { isString } from "util";
import storage from "../tools/storage";
import sysConfig from "../config/sysConfig";
import defineConfig from "../config/defineConfig";
import { isObject } from "util";

var getDictDataByOrgCode = function getDictDataByOrgCode(dictData, orgCode) {
  var tmpData = {};

  if (!orgCode) {
    return dictData;
  }

  _.forEach(dictData, function (dictArr, key) {
    var arr = dictArr.filter(function (dictObj) {
      return orgCode === dictObj.ORG_CODE;
    });

    arr.length && (tmpData[key] = arr);
  });

  return tmpData;
};
var isSingleByte = function isSingleByte(value, dictData) {
  if (-1 !== value.indexOf(",")) {
    return false;
  }

  var flag = true;
  dictData.forEach(function (obj, i) {
    if (obj.DICT_ITEM.length > 1) {
      return flag = false;
    }
  });

  return flag;
};

var getDictText = function getDictText(value, dictData) {
  var valArr = Array.isArray(value) ? value : isString(value) ? value.split(isSingleByte(value, dictData) ? "" : ",") : [],
      txtArr = [];

  valArr.length && valArr.forEach(function (v) {
    var obj = dictData.find(function (dictObj) {
      return dictObj.DICT_ITEM === v;
    });

    obj && txtArr.push(obj.DICT_ITEM_NAME);
  });

  return txtArr.length ? txtArr.join("，") : "";
};

export default {
  getDictData: function getDictData(arg, orgCode) {
    var cacheObj = storage.$storage.getJsonLocal(defineConfig.$definecfg.SYS_DICT_CACHE) || {},
        args = _.cloneDeep(arg),
        arrKeys = [],
        retObj = {},
        reqArrKeys = [],
        tmpObj = orgCode ? getDictDataByOrgCode(cacheObj, orgCode) : cacheObj;
    return new _Promise(function (resolve, reject) {
      if (!args) {
        resolve(null);
      }
      if (Array.isArray(args)) {
        arrKeys = args;
      }
      if (isString(args)) {
        arrKeys = args.split(",");
      }
      arrKeys.forEach(function (v, i) {
        if (tmpObj[v]) {
          retObj[v] = tmpObj[v];
          return;
        }
        reqArrKeys.push(v);
      });
      if (!reqArrKeys.length) {
        resolve(retObj);
        return;
      }
      sysConfig.$syscfg.K_Request("F0000018", {
        cacheType: "dictCache",
        keyCode: reqArrKeys.join(",")
      }).then(function (data) {
        var dataStr = data && data.Data && data.Data[0] && data.Data[0].cache;
        var linesDictData = dataStr && JSON.parse(dataStr) || {};
        if (isObject(linesDictData) && !_Object$keys(linesDictData).length) {
          resolve(retObj);
        }

        var cacheObj = storage.$storage.getJsonLocal(defineConfig.$definecfg.SYS_DICT_CACHE) || {};
        var tempObj = _Object$assign({}, cacheObj, linesDictData);
        storage.$storage.setLocal(defineConfig.$definecfg.SYS_DICT_CACHE, tempObj);
        resolve(_Object$assign({}, retObj, orgCode ? getDictDataByOrgCode(linesDictData, orgCode) : linesDictData));
      }).catch(function () {
        reject(arguments);
      });
    });
  },

  getDictByKey: function getDictByKey(key, orgCode) {
    var that = this;
    return new _Promise(function (resolve, reject) {
      if (!key || !isString(key)) {
        resolve(null);
      }
      that.getDictData([key], orgCode).then(function (obj) {
        resolve(obj && obj[key]);
      }).catch(function () {
        reject(arguments);
      });
    });
  },

  transformDictDes: function transformDictDes(dictData) {
    for (var i = 0; i < dictData.length; i++) {
      dictData[i]['dict_val'] = dictData[i]['DICT_ITEM'];
      dictData[i]['dict_des'] = dictData[i]['DICT_ITEM_NAME'];
    }
    return dictData;
  },

  transformFundDictDes: function transformFundDictDes(dictData) {
    for (var i = 0; i < dictData.length; i++) {
      dictData[i]['dict_val'] = dictData[i]['SUBITEM'];
      dictData[i]['dict_des'] = dictData[i]['SUBITEMNAME'];
    }
    return dictData;
  },

  transformDict: function transformDict(data, dictKeys, orgCode, shallow) {
    var that = this,
        isArray = data && Array.isArray(data),
        keysObj,
        dictKeys,
        retData;
    return new _Promise(function (resolve, reject) {
      if (isArray && !data.length || !data) {
        resolve(data);
      }

      if (!isArray && isObject(data) && !_Object$keys(data).length) {
        resolve(data);
      }
      var tempData = isArray ? data : [data];
      retData = !shallow ? JSON.parse(_JSON$stringify(tempData)) : tempData;
      keysObj = function () {
        var retObj = {};
        var dictKeysArr = Array.isArray(dictKeys) ? dictKeys : isString(dictKeys) ? dictKeys.split(",") : [dictKeys];
        dictKeysArr.forEach(function (v) {
          if (isObject(v)) {
            _Object$assign(retObj, v);
          } else if (isString(v)) {
            retObj[v] = v.replace("*", "");
          }
        });
        return retObj;
      }();
      that.getDictData(dictKeys = _Array$from(new _Set(_Object$values(keysObj))), orgCode).then(function (dictObj) {
        retData.forEach(function (sData) {
          _.each(keysObj, function (val, key) {
            var dictKey = val;
            var dictText;

            if (key.indexOf("*") > -1) {
              key = key.replace("*", "");
              if (!dictObj[dictKey]) {
                return;
              }
              if (isObject(sData)) {
                for (var name in sData) {
                  var value = sData[name];
                  if (name.indexOf(key) > -1) {
                    (dictText = that.getDictText(value, dictObj[dictKey])) && (sData[name + "_TEXT"] = dictText);
                  }
                }
              }
            } else {
              if (!dictObj[dictKey] || !sData || !sData[key]) {
                return;
              }
              (dictText = that.getDictText(sData[key], dictObj[dictKey])) && (sData[key + "_TEXT"] = dictText);
            }
          });
        });
        resolve(isArray ? retData : retData[0]);
      }).catch(function () {
        reject(arguments);
      });
    });
  },

  getDictText: getDictText,

  requestDict: function requestDict(dictCode) {
    var dicts = [];
    return new _Promise(function (resolve, reject) {
      sysConfig.$syscfg.K_Request("W0000006", {
        cacheType: "dictCache",
        keyCode: dictCode
      }).then(function (data) {
        var linesDictData = JSON.parse(data && data.Data && data.Data[0] && data.Data[0].cache || {});
        var ret = linesDictData[dictCode] || [];
        for (var i = 0; ret && i < ret.length; i++) {
          dicts.push({
            "dict_val": ret[i]["DICT_ITEM"],
            "dict_des": ret[i]["DICT_ITEM_NAME"],
            "dict_org": ret[i]["INT_ORG"]
          });
        }
        resolve(dicts);
      }).catch(function () {
        resolve(dicts);
      });
    });
  },

  getSysDict: function getSysDict(dictCode, val) {
    var that = this;
    var dictCodeName = dictCode;
    var rexp = "";
    var g_dicts = storage.$storage.getJsonLocal(defineConfig.$definecfg.SYS_DICT_CACHE) || {};
    var comString = "";
    if (dictCode.indexOf('[') > -1) {
      dictCodeName = dictCode.substring(0, dictCode.indexOf("["));
      rexp = dictCode.substring(dictCode.indexOf("[") + 1, dictCode.indexOf("]"));
      if (rexp.substr(0, 1) == "!") {
        comString = rexp.substr(1);
      } else {
        comString = rexp;
      }
    }

    var dicts = [];
    (g_dicts[dictCodeName] || []).forEach(function (v) {
      dicts.push({
        "dict_val": v["DICT_ITEM"],
        "dict_des": v["DICT_ITEM_NAME"],
        "dict_org": v["INT_ORG"]
      });
    });

    if (!val) {
      if (rexp != "") {
        var finaldicts = new Array();
        for (var i = 0; i < dicts.length; i++) {
          if (rexp.substr(0, 1) == "!") {
            if (dicts[i]['dict_val'].substr(0, comString.length) != comString) {
              finaldicts.push(dicts[i]);
            }
          } else {
            if (dicts[i]['dict_val'].substr(0, comString.length) == comString) {
              finaldicts.push(dicts[i]);
            }
          }
        }
        dicts = finaldicts;
      }

      return dicts;
    }
    if (dicts) {
      for (var i = 0; i < dicts.length; i++) {
        if (dicts[i]['dict_val'] == val) {
          return dicts[i]['dict_des'];
        }
      }
    }
    return val;
  },

  clearCache: function clearCache() {
    storage.$storage.removeLocal(defineConfig.$definecfg.SYS_DICT_CACHE);
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/tools/dict.js
// module id = 34
// module chunks = 2